import BaseModelAPI from '../BaseModelAPI';

export default class UserInfo extends BaseModelAPI {
	static entity = 'userinfo';
	static entityName = 'userinfo';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.userName = '';
			this.firstName = '';
			this.lastName = '';
			this.password = '';
			this.email = '';
			this.userLevel = 0;
			this.vendorId='';
			this.vendor={};
			this.approvalGroupId = '';
			this.approvalGroup = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async changePassword(this_, data, id) {
		return this_.$http.put(`${this.entityName}/changePassword/${id}`, data)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			this_.$store.dispatch('addErrorMessageGlobal', error);
			throw error;
		});
	}
	
	static async getRoles(this_, userName) {
		return this_.$http.get(`${this.entityName}/getroles/${userName}`)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			this_.$store.dispatch('addErrorMessageGlobal', error);
			throw error;
		});
	}
	
	static async addRole(this_, data) {
		return this_.$http.post(`${this.entityName}/addrole/`, data)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			this_.$store.dispatch('addErrorMessageGlobal', error);
			throw error;
		});
	}
	
	static async getJobPositions(this_, userName) {
		return this_.$http.get(`${this.entityName}/getjobpositions/${userName}`)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			this_.$store.dispatch('addErrorMessageGlobal', error);
			throw error;
		});
	}
	
	static async addJobPosition(this_, data) {
		return this_.$http.post(`${this.entityName}/addjobposition/`, data)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			this_.$store.dispatch('addErrorMessageGlobal', error);
			throw error;
		});
	}

}